import ACTION, { AUX_PAYMENT_STATE } from './creator'

const init_payment = {
  status: AUX_PAYMENT_STATE.PENDING,
  message: '',
  data: {
    list: [],
    pagination: {
      itemPerPage: 10,
      page: 1,
      totalItem: 0,
      totalPage: 1,
    },
  },
}

export const AuxPaymentData = (state = init_payment, { type, payload }) => {
  switch (type) {
    case ACTION.AUX_PAYMENT.PENDING:
    case ACTION.AUX_PAYMENT.SUCCESS:
      return { ...state, ...payload }
    case ACTION.AUX_PAYMENT.FAILURE:
      return { ...state, ...payload, data: init_payment.data }
    default:
      return state
  }
}
